module.exports = __webpack_public_path__ + "assets/img/nB4.ba70ef8c.jpg";